import { Component, OnDestroy, OnInit, AfterViewInit, inject, ViewChild } from '@angular/core';
import { DirectLineService } from './services/directline.service';
import { SCOUT_AI_MESSAGES } from './models/directline.models';
import { ScoutAiSessionComponent } from './scout-ai-session.component';

@Component({
    selector: 'app-scout-ai-popout',
    standalone: false,
    templateUrl: './scout-ai-popout.component.html',
    styleUrls: ['./scout-ai-popout.component.css', './scout-ai-shared.css']
})
export class ScoutAiPopoutComponent implements OnInit, OnDestroy, AfterViewInit {

    private directLineService = inject(DirectLineService);

    @ViewChild(ScoutAiSessionComponent) private session?: ScoutAiSessionComponent;

    private readonly MOBILE_BREAKPOINT = 768;
    private readonly VALID_MESSAGE_TYPES = [SCOUT_AI_MESSAGES.CLOSE];

    ngOnInit() {
        if (!window.opener && window.innerWidth <= this.MOBILE_BREAKPOINT) {
            window.close();
            return;
        }
        document.title = 'Navigator-Scout';
        window.addEventListener('message', this.handleMessage);
    }

    private handleMessage = (event: MessageEvent): void => {
        if (event.origin !== window.location.origin) return;
        if (!event.data || typeof event.data !== 'object') return;
        if (typeof event.data.type !== 'string') return;
        if (!this.VALID_MESSAGE_TYPES.includes(event.data.type)) return;

        if (event.data.type === SCOUT_AI_MESSAGES.CLOSE) {
            this.directLineService.disconnect();
            window.close();
        }
    }

    ngAfterViewInit() {
        this.session?.connect();
    }

    closeWindow(): void {
        this.cleanupAndClose();
    }

    dockToDrawer(): void {
        if (window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: SCOUT_AI_MESSAGES.DOCK }, window.location.origin);
        }
        this.cleanupAndClose();
    }

    private cleanupAndClose(): void {
        this.directLineService.disconnect();
        this.directLineService.storeSessionImmediate();
        window.close();
    }

    ngOnDestroy() {
        window.removeEventListener('message', this.handleMessage);
        this.directLineService.disconnect();
    }
}
